import { Row } from 'antd';
import React, { useEffect, useState } from 'react';
import ProjectData from '../../../Assets/JsonData/ProjectData.json'
import Project from './Project';


const AllProject = () => {

    const [projects, setProjects] = useState(ProjectData)

    useEffect(() => {
        setProjects(projects)
    }, [projects])


    return (
        <>

            <Row justify="center" style={{ padding: '4rem 0' }}>
                {projects.map(project => <Project project={project} key={project.id} />)}
            </Row>

        </>
    );
};

export default AllProject;